import React from 'react';
import { CustomSettings } from '../components';
import { useNavigate } from "react-router-dom";
import { withRouter } from 'us.common/wIthRouter';

interface ICnt_CustomSettings  {

}


const Cnt_CustomSettings = (props: ICnt_CustomSettings) => {
    const navigate = useNavigate();
    const onMinimize = () => {
        navigate('')
    }

    return (
        <CustomSettings.Home onMinimize={onMinimize} />
    )
}

export default withRouter(Cnt_CustomSettings);